import { z } from 'zod';

export const getVatCategoriesSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    code: z.string(),
    boid: z.string().optional(),
    isActive: z.boolean().optional(),
    isFromManager: z.boolean().optional(),
  })
);

export type GetVatCategories = z.infer<typeof getVatCategoriesSchema>;
